import React, { useState }  from 'react'
import { Form, Container, Header} from 'semantic-ui-react'
import { useFormik } from 'formik'
import { initialValues, validationSchema3 } from './AsesorForm.form'
import { DZ } from '../../../../../api'
import { useAuth } from '../../../../../hooks'
import "./AsesorForm.scss";
import ConfirmWithReason from './ConfirmWiithReason'
const DZController = new DZ();

export function AsesorDZForm3(props) {
    const { onClose, onReload, DZ } = props;
    const { accessToken } = useAuth();
    const { user: { email, firstname, lastname } } = useAuth();
    const CorreoAsesor = email;
    const nombreCompleto = `${firstname} ${lastname}`;
    const [showConfirm, setShowConfirm] = useState(false);

    const [confirmMessage, setConfirmMessage] = useState("");
    const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
    

    const formik = useFormik({
        initialValues: initialValues(DZ, CorreoAsesor, nombreCompleto),
        validationSchema: validationSchema3(),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            const data = {
                sAse2 : true,
                nombreoficial: formValue.nombreoficial,
            }
            try {
                if (DZ) {
                    await DZController.AproveDZ(accessToken, DZ._id, data);
                } else {
                   console.log("Esto no deberia de pasar")
                }
                onClose();
                onReload();
            } catch (error) {
                console.error(error);
            }
        }
    });
    
    const handleCancel = async (reason) => {
        try {

            await DZController.CancelDZ(accessToken, DZ._id, reason)
      
            onClose();
            onReload();
            onOpenCloseConfirm();
        } catch (error) {
          console.error(error)
        }
      }

      const openDesactivateActivateConfirm = () => {
        setConfirmMessage(`Cancelar Formula DZ ${DZ.folio}`);
        onOpenCloseConfirm();
  
      }

    return (
        <Form onSubmit={formik.handleSubmit} className='form'>
            <Container className='cotizacion-principal_info'>
                <p>Asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesornom}</span></p>
                <p>Correo asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesor}</span></p>
                <br></br>
                <p>Nombre del producto:<span className='cotizacion-principal_info-dxp'>{DZ.nombre}</span></p>
                <p>Familia del producto:<span className='cotizacion-principal_info-dxp'>{DZ.familia}</span></p>
                <p>Activos: <span className='cotizacion-principal_info-dxp'>{DZ.activos}</span></p>
                <p>Base: <span className='cotizacion-principal_info-base'>{DZ.base}</span></p>
                <p>Presentación: <span className='cotizacion-principal_info-activos'>{DZ.presentacion}</span></p>
                <p>Envase: <span className='cotizacion-principal_info-activos'>{DZ.envase}</span></p>
                <p>Área: <span className='cotizacion-principal_info-dxp'>{DZ.area}</span></p>
                {(DZ.sIyD && DZ.caducidad) && <p>Caducidad: <span className='cotizacion-principal_info-nombre'>{DZ.caducidad}</span></p>}
                <br></br>
                <p>Genero del paciente: <span className='cotizacion-principal_info-base'>{DZ.genero}</span></p>
                <p>Rango de edad: <span className='cotizacion-principal_info-dxp'>{DZ.rangoedad}</span></p>
                <p>Tipo de piel: <span className='cotizacion-principal_info-dxp'>{DZ.tipopiel}</span></p>
                <p>Padecimiento: <span className='cotizacion-principal_info-dxp'>{DZ.padecimiento}</span></p>
                <br></br>
                <p>Precio Objetivo: <span className='cotizacion-principal_info-activos'>{DZ.objetivo}</span></p>
                {(DZ.sOpe2 && DZ.preciounitario) && <p>Precio Unitario: <span className='cotizacion-principal_info-nombre'>{DZ.preciounitario}</span></p>}
                <Form.Input label="Nombre del producto oficial" name="nombreoficial" placeholder="Nombre del producto oficial" onChange={formik.handleChange} value={formik.values.nombreoficial} error={formik.errors.nombreoficial} />
            </Container>
            <Form.Button type='submit' primary fluid loading={formik.isSubmitting}>
                Aceptar
            </Form.Button>
            <Form.Button type='button' color='red' fluid onClick={openDesactivateActivateConfirm}>
                Cancelar
            </Form.Button>
            <ConfirmWithReason open={showConfirm} onCancel={onOpenCloseConfirm} onConfirm={handleCancel} content={confirmMessage} size='mini'></ConfirmWithReason>
        </Form>
    )
}
